module.exports = __webpack_public_path__ + "assets/media/day31.8e989d5a.mp3";